/**
 * LoginPage — вход/регистрация (полировка T-Bank уровня, aikido-стиль, тёмная тема).
 */

import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as api from "../api";
import { useAuth } from "../auth";

export function LoginPage() {
  const [mode, setMode] = useState<"login" | "register">("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      const res = mode === "login" ? await api.login(email, password) : await api.register(email, password);
      login(res.access_token, res.refresh_token, email);
      nav("/watchlist");
    } catch (err: any) {
      setError(err.message || String(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <div className="auth-h">{mode === "login" ? "Вход" : "Регистрация"}</div>
      <form onSubmit={onSubmit} className="auth-card">
        <div className="lbl" style={{ marginTop: 0 }}>Email</div>
        <input className="inp" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />

        <div className="lbl">Пароль</div>
        <input className="inp" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
          autoComplete={mode === "login" ? "current-password" : "new-password"} minLength={mode === "register" ? 8 : undefined} />

        {error && <div style={{ fontSize: 13, color: "var(--bad)", marginTop: 12 }}>{error}</div>}

        <button className="btn btn-primary" style={{ width: "100%", justifyContent: "center", marginTop: 16 }} type="submit" disabled={busy}>
          {busy ? "…" : mode === "login" ? "Войти" : "Создать аккаунт"}
        </button>
        <button type="button" className="linkbtn" onClick={() => setMode(mode === "login" ? "register" : "login")}>
          {mode === "login" ? "Нет аккаунта? Зарегистрироваться" : "Уже есть аккаунт? Войти"}
        </button>
      </form>
    </div>
  );
}
